import { render, staticRenderFns } from "./matchColorDetail.vue?vue&type=template&id=a0eda5d4&scoped=true"
import script from "./matchColorDetail.vue?vue&type=script&lang=js"
export * from "./matchColorDetail.vue?vue&type=script&lang=js"
import style0 from "./matchColorDetail.vue?vue&type=style&index=0&id=a0eda5d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0eda5d4",
  null
  
)

export default component.exports